import { adminApiClient } from './adminApiClient';
import {
  AdminLoginResponse,
  AdminSettingsResponse,
  AdminStats,
  PublicFlag,
  UpdateSettingsResponse,
} from '../types/admin';

export const adminService = {
  async login(email: string, password: string): Promise<AdminLoginResponse> {
    const { data } = await adminApiClient.post<AdminLoginResponse>('/admin/login', { email, password });
    return data;
  },

  /** Acceso de emergencia: intercambia el link privado por sesión admin. */
  async loginWithToken(token: string): Promise<AdminLoginResponse> {
    const { data } = await adminApiClient.post<AdminLoginResponse>('/admin/login', { token });
    return data;
  },

  async logout(refreshToken: string): Promise<void> {
    await adminApiClient.post('/auth/logout', { refreshToken });
  },

  async getStats(): Promise<AdminStats> {
    const { data } = await adminApiClient.get<AdminStats>('/admin/stats');
    return data;
  },

  async getSettings(): Promise<AdminSettingsResponse> {
    const { data } = await adminApiClient.get<AdminSettingsResponse>('/admin/settings');
    return data;
  },

  async updateSettings(settings: Record<string, boolean | number>): Promise<UpdateSettingsResponse> {
    const { data } = await adminApiClient.put<UpdateSettingsResponse>('/admin/settings', { settings });
    return data;
  },

  /** Flags públicas (sin sesión): usadas por el runtime del paciente. */
  async getPublicFlags(): Promise<{ flags: PublicFlag[] }> {
    const { data } = await adminApiClient.get<{ flags: PublicFlag[] }>('/admin/settings/public');
    return data;
  },
};
